// src/pages/CarritoPage.js
import React from 'react';
import { useCart } from '../context/CartContext';
import { Trash2 } from 'lucide-react';
import './CarritoPage.css';

const CarritoPage = () => {
  const { cartItems, removeProduct, cartTotal } = useCart();

  const formatCurrency = (value) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(value);

  const handleSendToWhatsApp = () => {
    let message = '¡Hola! Quisiera hacer el siguiente pedido:\n\n';
    cartItems.forEach(item => {
      const presentationLabel = item.price.presentacion || `${item.price.unidades} unidades`;
      message += `*${item.name}* - ${presentationLabel} (x${item.quantity})\n`;
      message += `  - Precio unitario: ${formatCurrency(item.price.valor)}\n`;
      message += `  - Subtotal: ${formatCurrency(item.quantity * item.price.valor)}\n\n`;
    });
    message += `*TOTAL DEL PEDIDO: ${formatCurrency(cartTotal)}*`;

    const whatsappNumber = '573043882058';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  if (cartItems.length === 0) {
    return (
      <div className="carrito-page empty-cart">
        <h2>Tu carrito está vacío</h2>
        <p>Añade productos desde nuestro catálogo para poder hacer un pedido.</p>
      </div>
    );
  }

  return (
    <div className="carrito-page">
      <div className="container">
        <h1>Resumen de tu Pedido</h1>
        <div className="cart-items-list">
          {cartItems.map(item => {
            const presentationLabel = item.price.presentacion || `${item.price.unidades} unidades`;
            const presentationKey = item.price.presentacion || item.price.unidades;
            return (
              <div key={`${item.id}-${presentationKey}`} className="cart-item">
                <img src={item.image} alt={item.name} className="cart-item-image" />
                <div className="cart-item-details">
                  <h3>{item.name}</h3>
                  <p>Presentación: {presentationLabel}</p>
                  <p>Cantidad: {item.quantity}</p>
                  <p>Precio Unitario: {formatCurrency(item.price.valor)}</p>
                </div>
                <div className="cart-item-actions">
                  <p className="cart-item-subtotal">{formatCurrency(item.quantity * item.price.valor)}</p>
                  <button onClick={() => removeProduct(item.id, presentationKey)} className="remove-button">
                    <Trash2 size={20} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        <div className="cart-summary">
          <div className="cart-total">
            <h2>Total del Pedido:</h2>
            <h2>{formatCurrency(cartTotal)}</h2>
          </div>
          <button onClick={handleSendToWhatsApp} className="checkout-button">
            Finalizar Pedido por WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarritoPage;